import type { TaskListItem } from "@labeling-tools/api/field-rep/generated/types.gen";

export enum TaskRowAction {
  Open = "open",
  Resume = "resume",
  Release = "release",
}

/**
 * What a user can do with a task in the list view:
 * - Labelers get their work only through "Start labeling", their list is read-only
 * - Staff can:
 *   - open a pending task (and claim it)
 *   - resume the task they hold
 *   - release a task someone else holds
 */
export const taskRowAction = (
  task: TaskListItem,
  me: { email: string; is_staff: boolean },
): TaskRowAction | null => {
  if (!me.is_staff) {
    return null;
  }

  if (task.status === "PENDING") {
    return TaskRowAction.Open;
  }

  if (task.status !== "IN_REVIEW") {
    return null;
  }

  if (task.reviewer?.email.toLowerCase() === me.email.toLowerCase()) {
    return TaskRowAction.Resume;
  }

  return TaskRowAction.Release;
};
